<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="100px" :rules="rules">
      <el-form-item label="供应商名称" prop="org_name">
        <el-input v-model="ruleForm.org_name" maxlength="25" show-word-limit />
      </el-form-item>
      <el-form-item label="联系人" prop="org_contact_name">
        <el-input v-model="ruleForm.org_contact_name" maxlength="10" show-word-limit />
      </el-form-item>
      <el-form-item label="联系电话" prop="org_contact_phone">
        <el-input v-model="ruleForm.org_contact_phone" />
      </el-form-item>
      <el-form-item label="供应商地址" prop="org_contact_address">
        <el-input v-model="ruleForm.org_contact_address" maxlength="50" show-word-limit />
      </el-form-item>
      <el-form-item label="供应商邮箱" prop="org_contact_mail">
        <el-input v-model="ruleForm.org_contact_mail" />
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog cz" @click="resetForm">重置</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'

export default {
  name: '',
  data () {
    return {
      service: 'org_provider',
      id_name: 'org_id',
      ruleForm: {},
      rules: {
        org_name: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        org_contact_phone: [
          {
            pattern: /(^([0-9]{3,4}-)?[0-9]{7,8}$)|(^(0|86|17951)?1[3-9][0-9]{9}$)/,
            message: '请输入有效的电话号码'
          }
        ],
        org_contact_mail: [
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: '请输入有效的邮箱地址'
          }
        ]
      }
    }
  },

  props: ['rowData'],

  created () {
    this.getRow(this.rowData)
  },

  methods: {
    getRow (data) {
      for (const k in data) {
        this.$set(this.ruleForm, k, data[k])
      }
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          Backend.editRow(this, this.ruleForm, undefined, '供应商管理')
        }
      })
    }
  }
}
</script>
